import ajax from "plugins/AjaxService"
import { Farm } from "types/Farm"
import { GrowUnit } from "types/GrowUnit"
import { SharedServices } from "types/Service"
import humps from "humps"
import { Scopes } from "types/Task"
import { buildFarmVirtual } from "mocks/data/factory/farm"



// url builder
const urlBuilder = (farmId?: number): string => `farms${farmId ? `/${farmId}` : ""}`

/**
 * retrieves all FARMS
 * https://airilabs.myjetbrains.com/youtrack/articles/ZOS-A-107/index
 */
function index(): Promise<{ data: Farm[] }> {
	return ajax.get(urlBuilder())
}

/**
 * Recupera tutte le GROW-UNITs di una specifica FARM
 * https://airilabs.myjetbrains.com/youtrack/articles/ZOS-A-178/index
 */
function getGrowUnits(idFarm: number): Promise<{ data: GrowUnit[] }> {
	return ajax.get(`${urlBuilder(idFarm)}/grow_units`)
}

/**
 * Recupera tutti i dati di una specifica FARM
 * https://airilabs.myjetbrains.com/youtrack/articles/ZOS-A-108/get
 * @param {*} id identificativo della FARM
 */
async function get(id: number): Promise<{ data: Farm }> {

	// se è una VIRTUAL-FARM la creo al volo
	if (id == 0) {
		return { data: buildFarmVirtual() }
	}

	// chiamo l'API
	const response = await ajax.get(urlBuilder(id), null, { noCamelize: true })
	return normalizeFarm(response)
}

/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-61135
 */
function scopes(farmId: number): Promise<{ data: Scopes }> {
	return ajax.get(`${urlBuilder(farmId)}/tasks/scopes`)
}


/**
 * Recupera tutti i dati della farm CURRENT (per PLC)
  */
async function current(rawData: boolean = false): Promise<{ data: Farm }> {
	const response = await ajax.get("zero/farms/current", null, { noCamelize: true })
	return rawData ? response : normalizeFarm(response)
}

/**
 * Imposta la farm CURRENT (per PLC)
  */
function setup(farm: Farm): Promise<{ data: Farm }> {
	return ajax.post("zero/farms/current", farm, { noDecamelize: true })
}

/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-38955
 */
function sharedServices(): Promise<{ data: SharedServices }> {
	return ajax.get("zero/farms/shared_services")
}


const farmApi = {
	get,
	index,
	getGrowUnits,
	scopes,

	sharedServices,
	current,
	setup,
}

export default farmApi


/**
 * Sistemo i dati che non devono subire il processo di "camelize" 
 * altrimenti mi cambia i nomi dei parametri che poi non riesco ad usare
 */
function normalizeFarm(response) {
	// alcuni parametri non devono essere trasformati per il "camelize"
	const mapConfig = response.data.map_config
	const components = response.data.edge_services_config
	delete response.data.map_config
	delete response.data.edge_services_config

	response.data = humps.camelizeKeys(response.data)

	response.data.mapConfig = mapConfig
	response.data.edgeServicesConfig = components
	// ---

	return response
}